import { createFileRoute } from '@tanstack/react-router'
import { ManufacturersPage } from '@/pages/manufacturers'

export const Route = createFileRoute('/_authenticated/manufacturers/')({
  staticData: { title: 'Manufacturers' },
  component: ManufacturersPage,
})
